import color from './theme-color.js'
import media from './theme-media.js'
import font from './theme-font.js'

const padding = {
  smallest: '1.5rem',
  extraSmall: '2rem',
  small: '2.5rem',
  mediumSmall: '3.75rem',
  medium: '5rem',
  mediumLarge: '7.5rem',
  large: '10rem',
  horizontal: 'var(--padding-horizontal)',
  section: 'var(--section-padding)'
}

const section = {
  width: {
    extraSmall: '60rem',
    small: '70rem'
  }
}

const theme = {
  color,
  font,
  padding,
  media,
  section,
}

theme.pad = padding

export default theme